export const MAX_LEGAL_COMPANY_NAME_LENGTH = 100

export const VALID_JAPAN_IDENTIFICATION_NUMBER_REGEXP =
  /^[0-9]{4}-[0-9]{2}-[0-9]{6}$/

export const VALID_JAPAN_SECONDHAND_NUMBER_REGEXP = /^[0-9]{12}$/
